module.exports = __webpack_public_path__ + "img/004.9aa9fb85.jpg";